var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('va-data-table',{attrs:{"fields":_vm.fields,"data":_vm.users,"loading":_vm.loading,"totalPages":_vm.totalPages,"api-mode":""},on:{"page-selected":_vm.readPage}})}
var staticRenderFns = []

export { render, staticRenderFns }